<template>
  <div class="schedule">
    <el-row>
      <el-col :span="6">
        <div class="scheduleTimeline">
          <el-timeline>
            <el-timeline-item
              v-for="(event, key) in dateList"
              :key="key"
              :size="event.size"
              :color="event.color"
              :timestamp="event.date"
            >
              {{ event.label }}
            </el-timeline-item>
          </el-timeline>
        </div>
      </el-col>

      <el-col :span="18">
        <div class="scheduleCreateForm">
          <el-form
            ref="scheduleForm"
            label-width="100px"
            :model="scheduleForm"
            class="scheduleForm"
            :rules="rules"
          >
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item
                  label="Start date"
                  prop="start_date"
                >
                  <el-input
                    v-model="scheduleForm.start_date"
                    disabled
                  />
                </el-form-item>
                <el-form-item
                  label="End date"
                  prop="end_date"
                >
                  <el-date-picker
                    v-model="scheduleForm.end_date"
                    prop="end_date"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptionsEndDate"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="Reminder"
                  prop="reminder_1"
                >
                  <el-date-picker
                    v-model="scheduleForm.reminder_1"
                    prop="reminder_1"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                  />
                </el-form-item>
                <el-form-item
                  label="Reminder"
                  prop="reminder_2"
                >
                  <el-date-picker
                    v-model="scheduleForm.reminder_2"
                    prop="reminder_2"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                  />
                </el-form-item>
                <el-form-item
                  label="Reminder"
                  prop="reminder_3"
                >
                  <el-date-picker
                    v-model="scheduleForm.reminder_3"
                    prop="reminder_3"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item>
              <el-button @click="resetForm">
                Cancel
              </el-button>
              <el-button
                type="primary"
                @click="submit"
              >
                Update
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import api from '@/api';

export default {
  props: {
    lgpr: {
      type: Object,
      default() {
        return {
          id: 0,
          number: 0,
          status: 'draft',
          start_date: this.$moment().format('YYYY-MM-DD'),
          end_date: null,
          reminder_1: null,
          reminder_2: null,
          reminder_3: null,
        };
      },
    },
  },

  data() {
    return {
      scheduleForm: {
        start_date: '',
        end_date: null,
        reminder_1: null,
        reminder_2: null,
        reminder_3: null,
      },
      rules: {
        // end_date: [{ required: true, message: 'End date is required', trigger: 'blur' }],
      },
      pickerOptionsEndDate: {
        firstDayOfWeek: 1,
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
        shortcuts: [{
          text: 'Today',
          onClick(picker) {
            picker.$emit('pick', new Date());
          },
        }, {
          text: 'In a week',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          },
        }, {
          text: 'In a month',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
            picker.$emit('pick', date);
          },
        }],
      },
      pickerOptions: {
        firstDayOfWeek: 1,
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
    };
  },

  computed: {
    dateList() {
      const list = [];
      Object.keys(this.scheduleForm).forEach((key) => {
        if (this.scheduleForm[key] !== '') {
          // list[key] = this.scheduleForm[key];
          let label;
          let color;
          let size;
          switch (key) {
            case 'start_date':
              label = 'Start date';
              size = 'large';
              color = 'green';
              break;
            case 'end_date':
              label = 'End date';
              size = 'large';
              color = 'red';
              break;
            case 'reminder_1':
            case 'reminder_2':
            case 'reminder_3':
              label = 'Reminder';
              break;
            default:
              label = '';
          }
          if (label && this.scheduleForm[key]) {
            list.push({
              date: this.scheduleForm[key],
              label,
              name: key,
              size,
              color,
            });
          }
        }
      });

      list.sort((a, b) => (this.$moment(a.date).isBefore(b.date) ? -1 : 1));

      return list;
    },
  },

  watch: {
    dateList(list) {
      const data = {};
      list.forEach((el) => {
        data[el.name] = el.date;
      });
    },
  },

  mounted() {
    this.resetForm();
  },

  methods: {
    resetForm() {
      this.scheduleForm = Object.assign(this.scheduleForm, this.lgpr);
      if (!this.scheduleForm.start_date) this.scheduleForm.start_date = this.$moment().format('YYYY-MM-DD');
      this.$refs.scheduleForm.clearValidate();
    },

    submit() {
      this.$refs.scheduleForm.validate(async (valid) => {
        if (valid) {
          try {
            const response = await api.updateCurrentLGPR(this.scheduleForm);
            this.$emit('update:lgpr', response.data);
          } catch (err) {
            if (err.msg) {
              this.$message.error(err.msg);
            }
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.schedule {
  .scheduleTimeline,
  .scheduleCreateForm {
    padding: 20px;
    float: left;
  }

  .scheduleTimeline {
    width: 180px;
  }

  .scheduleCreateForm {
    border-style: solid;
    border-width: 1px;
    border-radius: 4px;
    border-color: #eee;
    padding-top: 15px;
    padding-bottom: 0;
  }
}
</style>
